<template>
  <div class="row row-xs">
    <div
      class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-2"
      v-for="(a, i) in attachments"
      :key="i"
    >
      <div @click="showDetail(a)" class="card card-file" role="button">
        <div class="card-file-thumb overflow-hidden">
          <img
            v-if="getFileIcon(a.e) == 'image'"
            :src="`${a.l}?w=280&h=120&mode=pad`"
            class="wd-100p"
          />
          <img
            v-else-if="getFileIcon(a.e) == 'video'"
            :src="`${a.c}?w=280&h=120&mode=pad`"
            class="wd-100p"
          />
          <i v-else :class="`far fa-file-${getFileIcon(a.e)}`"></i>
        </div>
        <div class="card-body">
          <div class="d-flex">
            <!-- <feather :type="getFileIcon(a.e)" :size="32" :stroke-width="1" class="text-secondary mg-r-10"></feather> -->

            <div class="avatar avatar-sm mg-r-10 wd-18p">
              <span
                :class="
                  `avatar-initial rounded-circle bg-${
                    a.isCompleted ? 'success-light' : 'gray-700'
                  } text-white`
                "
              >
                <feather v-if="a.isCompleted" type="check" :size="16"></feather>
                <i v-else :class="`far fa-file-${getFileIcon(a.e)}`"></i>
              </span>
            </div>
            <div class="wd-80p">
              <h6>
                <a class="link-02">{{ a.t != "" ? a.t : a.n }}</a>
              </h6>

              <div class="d-flex justify-content-between">
                <p class="tx-12 text-muted text-uppercase">{{ a.e }}</p>
                <span>{{ getSize(a.s) }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="marker-icon marker-success pos-absolute t--1 l--1" v-if="a.isCompleted">
              <feather class="mg-l-5 my-n1" type="check" :size="16"></feather>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { getSize, getFileIcon } from "@/libs/tools";

export default {
  props: {
    box: {
      type: Object,
      default: () => {}
    },
    attachments: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getSize(size) {
      return getSize(size);
    },
    getFileIcon(ex) {
      return getFileIcon(ex);
    },
    showDetail(t) {
      if (this.$route.params.bot == 6 || this.$route.params.bot == 286) {
        this.$emit("on-detail", t);
      } else {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: this.$route.params.id,
            cid: this.$route.params.cid,
            bid: this.box.id,
            iid: t.id,
            bot: this.box.ot
          }
        });
      }
    }
  }
};
</script>

<style></style>
